import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== "undefined") {
    window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault();
        deferredPrompt = e;
        listeners.forEach((l) => l());
    });
}

export function useInstallPrompt() {
    const [canInstall, setCanInstall] = useState(!!deferredPrompt);
    useEffect(() => {
        const update = () => setCanInstall(!!deferredPrompt);
        listeners.add(update);
        return () => listeners.delete(update);
    }, []);
    const promptInstall = async () => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        await deferredPrompt.userChoice;
        deferredPrompt = null;
        listeners.forEach((l) => l());
    };
    return { canInstall, promptInstall };
}

export default function InstallBanner() {
    const { canInstall, promptInstall } = useInstallPrompt();
    const [dismissed, setDismissed] = useState(false);
    if (!canInstall || dismissed) return null;
    return (
        <div
            data-testid="pwa-install-banner"
            className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-4 bg-[#12121A] border border-[#FF5500]/50 rounded-2xl px-5 py-3 shadow-[0_10px_40px_rgba(255,85,0,0.25)] backdrop-blur-md"
        >
            <div>
                <p className="font-display font-bold uppercase tracking-wider text-white text-sm">Install YKPBL</p>
                <p className="text-xs text-slate-400">Court-side access, right from your home screen.</p>
            </div>
            <button
                data-testid="pwa-install-button"
                onClick={promptInstall}
                className="flex items-center gap-2 bg-[#FF5500] hover:bg-[#E04800] text-white font-display font-bold uppercase tracking-wider text-xs px-4 py-2 rounded-full transition-colors duration-200"
            >
                <Download className="w-4 h-4" /> Install
            </button>
            <button
                data-testid="pwa-install-dismiss"
                onClick={() => setDismissed(true)}
                className="text-slate-500 hover:text-white transition-colors duration-200"
                aria-label="Dismiss install banner"
            >
                <X className="w-4 h-4" />
            </button>
        </div>
    );
}
